export const roles = [
  ['/profile', '/games', '/file-manager'], // Role 0 - Basic user with profile access only
  ['/profile', '/games', '/file-manager'], // Role 1 - Basic user with profile access only
  [
    '/establishements',
    '/classes',
    '/users',
    '/subjects',
    '/remarques',
    '/exams',
    '/exercices',
    '/inventory',
    '/inventory-types',
    '/inventory-statistics',
    '/type-exams',
    '/type-remarques',
    '/payment-categories',
    '/payments',
    '/expenditures',
    '/profile',
    '/promotions',
    '/statistiques',
    '/chatbot',
    '/email-management',
    '/users/infos',
    '/games',
    '/file-manager',
  ], // Role 2 - Admin (Full access)
  ['/exercices', '/remarques', '/profile', '/exams', '/users/details', '/games', '/file-manager'], // Role 3 - Teacher
  ['/exercices', '/remarques', '/profile', '/exams', '/payments', '/games', '/file-manager'], // Role 4 - Student
  ['/kids', '/exercices', '/remarques', '/profile', '/exams', '/payments', '/games', '/file-manager'], // Role 5 - Parent
  ['/payments', '/profile', '/payment-categories', '/users', '/games', '/file-manager'], // Role 6 - Finance Manager
  ['/inventory', '/inventory-types', '/profile', '/games', '/file-manager'], // Role 7 - Stock Manager
  ['/profile', '/payments', '/games', '/file-manager'], // Role 8 - Limited Student (Profile + Payments only)
]

export const resolveRoleIndex = (role: string | number | undefined | null): number | null => {
  if (role === undefined || role === null) {
    return null
  }
  const numeric = Number(role)
  if (!Number.isNaN(numeric)) {
    return numeric
  }
  const match = `${role}`.match(/\d+/)
  if (match) {
    const extracted = Number(match[0])
    return Number.isNaN(extracted) ? null : extracted
  }
  return null
}
